// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Automations_Content($location_id: uuid!, $app_id: uuid!) {
  apps_automations(location_id: $location_id, app_id: $app_id) {
    id
    automations
  }
}

`